import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import careHelpfulFunctions from '../../careHelpfulFunctions.jsx';

import LayoutCard from './layoutCard.jsx';

const baseFieldsetMixin = {
    mixins: [BaseComponent],
    components: {
        LayoutCard,
    },
    data: () => ({
    }),
    props: {
        /**
         * When false, skip first-field autofocus at the root fieldset.
         * Nested fieldsets already skip autofocus (depth > 0).
         */
        autofocusFirst: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        hasVisibleFieldsetTitle() {
            return !!(this.element && this.Title && !this.element.notitle && !this.notitle);
        },
        childNestedInTitledFieldset() {
            return this.nestedInTitledFieldset || (this.element?.type === 'fieldset' && this.hasVisibleFieldsetTitle());
        },
        usesColspan(type) {
            switch (type) {
                case 'fieldset':
                case 'conditional':
                case 'tabs':
                case 'help':
                case 'paragraph':
                    return true;
                default:
                    return false;
            }
        },
        generateElements(h, form, layoutType) {
            let LayoutType = utils.getComponentByTag(layoutType);

            const elements = [];
            for (let i = 0; i < form.length; i++) {
                const element = form[i];

                // Nice idea, but the current component does not have correct values for ParentModel (and potentially others) because "this"
                // refers to the fieldset, not the element. To marshal the "this" properties into the condition function that apply to the
                // element will require additional thought. (6/13/2021)
                //if (element.$$condition && typeof element.$$condition === 'function' && !element.$$condition(this, careHelpfulFunctions))
                //    continue;

                //if (!element.type)
                //    debugger;

                let elementType = (element.type || 'missing').toLowerCase();
                let formtype = `sform-${elementType}`;

                let modelkey;

                if (element.key) {
                    modelkey = [...element.key];

                    if (this.modelkey && this.modelkey.length > 0)
                        for (let j = 0; j < this.modelkey.length && j < modelkey.length; j++)
                            modelkey[j] = this.modelkey[j];
                }
                else
                    modelkey = this.modelkey;

                if (!element.$objectId)
                    element.$objectId = utils.generateUUID();

                // name={element.title || (element.key ? element.key[element.key.length - 1] : 'unnamed')}
                //if (i>14)
                //    elements.push(<div>${layoutType}[${i}] / formtype:${formtype}</div>);
                //else
                    elements.push(
                        <LayoutType
                            key={i + '_' + element.$objectId}
                            formtype={formtype}
                            colspan={this.usesColspan(element.type)}
                            xxname={this.getElementName(element)}
                            root={this.root}
                            element={element}
                            form={element.items}
                            cmodel={this.cmodel}
                            modelkey={modelkey}
                            depth={this.depth + 1}
                            fieldset_index={i}
                            autofocus={this.autofocusFirst !== false && this.depth === 0 && i === 0}
                            layouttype={layoutType}
                            appearance={this.appearance}
                            type="FormField"
                            noinput={this.noinput}
                            schema={this.schema}
                            scopeitems={this.scopeitems}
                            controlscope={this.controlscope}
                            nestedInTitledFieldset={this.childNestedInTitledFieldset()}
                        >
                        </LayoutType>
                    );
            }
            return elements;
        }
    },
};

export default baseFieldsetMixin;